<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        small
        icon
        v-on="on"
      >
        <v-icon color="hrissecondary">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Cost Center"
      text="Create Employee Cost Center"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <v-col
            cols="12"
            class="pb-0"
          >
            <v-autocomplete 
              v-model="costCenter" 
              label="Cost Center"
              :items="costCenters"
              item-disabled="disable"
              item-text="name"
              item-value="id"
              outlined
            />
          </v-col>
          
          <v-col
            cols="12"
            class="pb-0"
          >
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startDateDisplay"
                  v-validate="'required'"
                  :error-messages="errors.collect('startDateDisplay')"
                  data-vv-name="startDateDisplay"
                  data-vv-as="start date"
                  label="Start date"
                  outlined
                  class="label-position"
                  readonly
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                no-title
                :min="minStartDate"
                @input="startDateMenu = false"
              />
            </v-menu> 
          </v-col>
        </v-row>
      </v-container> 

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          class="px-10"
          :disabled="progressing"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="hrissecondary"
          class="px-10 white--text"
          :loading="progressing"
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      companyEmployeeUid: {
        type: String,
        default: null,
        required: true,
      },
      companyUid: {
        type: String,
        default: null,
        required: true,
      },
      minStartDate: {
        type: String,
        required: true,
      },
      companyEmployeeActiveCostCenter: {
        type: Object,
        required: true,
      },
    },

    data () {
      return {
        dialog: false,
        loading: false,
        progressing: false,
        costCenters: [],
        costCenter: null,
        startDateMenu: false,
        startDate: null,
      }
    },

    computed: {
      startDateDisplay () {
        return this.startDate ? this.$moment(this.startDate, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
    },

    watch: {
      dialog: function (val) {
        if (!val) return this.$resetData()

        this.$api.costCenters().list(this.companyUid)
          .then(response => {
            this.costCenters = _.orderBy(response.data, ['name'], ['asc'])

            this.costCenters.forEach(costCenter => {
              if (costCenter.id !== this.companyEmployeeActiveCostCenter.cost_center_id) {
                costCenter.disable = false
              } else {
                costCenter.disable = true
                costCenter.name = costCenter.name + ' (Still active)'
              }
            })
          })
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            
            this.$api.companyEmployeeCostCenters().create(this.prepareFormData())
              .then(res => {
                this.$emit('created')
                this.$snack({ message: res.data.status })

                this.dialog = false
                this.progressing = false
              })
              .catch((err) => {
                if (err.response.status === 422) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.message, 
                  })
                }            
            
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return { 
          'cost_center_id': this.costCenter,
          'start_date': this.startDate,
          'company_employee_uid': this.companyEmployeeUid,
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
